import r from '../utils/request'

// Leave out groupId on your own recipe to see the conversations from every group
export const getComments = (recipeId, groupId) => {
  return r.get(`/recipes/${recipeId}/comments`, groupId ? { group_id: groupId } : {})
}

// photos: shrunk JPEGs (see shrinkPhoto). With photos it goes as a file upload.
export const createComment = (recipeId, { groupId, body, parentId, photos = [] }) => {
  const fields = {
    group_id: groupId,
    body,
    ...(parentId ? { parent_id: parentId } : {}),
  }
  if (!photos.length) {
    return r.post(`/recipes/${recipeId}/comments`, fields)
  }

  const form = new FormData()
  Object.entries(fields).forEach(([key, value]) => form.append(key, value))
  photos.forEach((photo, index) => form.append('photos[]', photo, `photo-${index + 1}.jpg`))
  return r.post(`/recipes/${recipeId}/comments`, form)
}

export const deleteComment = (id) => {
  return r.delete(`/comments/${id}`)
}
